import { Pipe, PipeTransform } from '@angular/core';
import { gfRelativeDateFunction } from './date.functions';

@Pipe({
    name: 'gfRelativeDate'
})
export class DateGfRelativeDatePipe implements PipeTransform {
    transform(inputValue?: any, locale?: string): string {
        return gfRelativeDateFunction(inputValue, locale);
    }
};